module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.groenekaart == 'A') ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "alert alert-success"
  }, [_vm._v("\r\n\t\t\tOp " + _vm._s(_vm.groenekaartdatum) + " heeft u een nieuwe groene kaart aangevraagd. Binnen twee werkdagen sturen wij u de groene kaart toe (via de post).\r\n\t\t")])]) : _vm._e(), _vm._v(" "), (_vm.gkrequeststs == 'E') ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "alert alert-danger"
  }, [_vm._v("\r\n\t\t\tHet aanvragen van de groene kaart is mislukt. Probeer het later nog eens.\r\n\t\t")])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-031a381d"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/components/polisdetails/gkaangevraagd.vue
// module id = 62
// module chunks = 0